<template>
  <a-row>
    <a-col>
      <h4>Календарь волонтёрства</h4>
    </a-col>
    <a-col>
      <div class="year">
        <a-select
          id="year"
          placeholder="Год"
          v-model:value="year"
          :options="years"
        />
      </div>
    </a-col>
  </a-row>
  <div class="calendar-wrapper">
    <div class="calendar">
      <div
        v-for="(cell, idx) in days"
        :key="idx"
        :class="
          'cell' + (!cell.month ? ' empty' : cell.active ? ' active' : '')
        "
      >
        <span v-if="cell.day === 1" class="month">{{ cell.month }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, onMounted, ref, watch } from 'vue';
  import dayjs from 'dayjs';

  const days = ref([]);
  const years = ref([]);
  const year = ref(0);

  const props = defineProps({
    volunteering: {
      type: Array,
      required: true,
    },
  });

  const months = [
    'Янв',
    'Фев',
    'Март',
    'Апр',
    'Май',
    'Июнь',
    'Июль',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ];
  const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

  const getYears = () => {
    const tmpYears = [];
    let maxYear = 0;
    for (let i = props.volunteering.length - 1; i >= 0; i--) {
      const y = dayjs(props.volunteering[i].date).year();
      if (!tmpYears.some((item) => item.value === y)) {
        tmpYears.push({ value: y });
        maxYear = Math.max(maxYear, y);
      }
    }
    tmpYears.sort(function (a, b) {
      return b.value - a.value;
    });

    years.value = tmpYears;
    year.value = maxYear;
  };

  const getDays = () => {
    const data = [];
    const firstDate = new Date(year.value, 0, 1);
    const firstWeekDay = [7, 1, 2, 3, 4, 5, 6][firstDate.getDay()];

    if (firstWeekDay > 1) {
      for (let d = 1; d < firstWeekDay; d++) {
        data.push({
          month: '',
          day: '',
          active: false,
        });
      }
    }

    for (let m = 0; m <= 11; m++) {
      for (let d = 1; d <= daysInMonth(year.value, m); d++) {
        const date = new Date(year.value, m, d);
        const dateString = new Intl.DateTimeFormat('en-CA').format(date); // yyyy-mm-dd
        const item = props.volunteering.find((x) => x.date === dateString);

        data.push({
          month: months[m],
          day: d,
          active: item !== undefined,
        });
      }
    }

    return data;
  };

  onMounted(() => {
    const date = new Date();
    year.value = date.getFullYear();
  });

  watch(
    () => props.volunteering.length,
    () => {
      getYears();
    }
  );

  watch(
    () => [year.value, props.volunteering.length],
    () => {
      days.value = getDays();
    }
  );
</script>

<style lang="scss" scoped>
  .year {
    & > div {
      margin: -10px 0 0 20px;
    }
  }
  .calendar-wrapper {
    width: 100%;
    overflow-y: auto;

    .calendar {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(12px, 1fr));
      grid-template-rows: repeat(7, minmax(13px, 1fr));
      grid-auto-flow: column;
      gap: 2px;
      width: 100%;
      align-items: flex-start;
      position: relative;
      padding-top: 32px;

      .month {
        position: absolute;
        top: 0;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }

      .cell {
        width: 100%;
        aspect-ratio: 1 / 1;
        background: #b4df8a;
        border-radius: 1px;

        &.empty {
          background: none;
        }

        &.active {
          background: #579b15;
        }
      }
    }
  }
</style>
